import { Link } from "react-router-dom";
import { NAVY } from "./reportNavyTokens.js";

/**
 * Document switcher (underline tabs) + export actions for audit vs remediation reports.
 */
export default function ReportExportBar({ projectId, snapshotId, activeDoc = "audit", variant = "navy" }) {
  const sid = snapshotId ? encodeURIComponent(String(snapshotId)) : "";
  const base = `/project/${encodeURIComponent(projectId)}`;
  const auditPath = sid ? `${base}/report/${sid}` : `${base}/report`;
  const remediationPath = sid ? `${base}/remediation/${sid}` : `${base}/remediation`;
  const apiBase = `/api/projects/${encodeURIComponent(projectId)}/snapshots/${encodeURIComponent(snapshotId || "")}`;
  const isAudit = activeDoc === "audit";
  const pdfHref = isAudit ? `${apiBase}/report.pdf` : `${apiBase}/remediation-summary.pdf`;
  const htmlHref = isAudit ? `${apiBase}/report.html` : `${apiBase}/remediation-summary.html`;

  const isNavy = variant === "navy";
  const accent = isNavy ? "#2FC9AB" : "var(--accent, #2fc9ab)";
  const textActive = isNavy ? NAVY.fg : "var(--idaxis-print-text, #0b1b34)";
  const textMuted = isNavy ? NAVY.mut : "var(--idaxis-print-muted, #64748b)";
  const border = isNavy ? NAVY.line : "var(--idaxis-print-border, #e5e7eb)";
  const surface = isNavy ? NAVY.panel : "var(--idaxis-print-bg, #fff)";

  const btnStyle = {
    display: "inline-flex",
    alignItems: "center",
    padding: "7px 12px",
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 600,
    textDecoration: "none",
    border: `1px solid ${isNavy ? NAVY.line2 : border}`,
    background: isNavy ? NAVY.panel2 : "var(--idaxis-print-bg, #fff)",
    color: textActive,
  };

  if (!snapshotId) return null;

  const tabs = [
    { key: "audit", label: "Full audit report", to: auditPath, active: isAudit },
    { key: "remediation", label: "Remediation summary", to: remediationPath, active: !isAudit },
  ];

  return (
    <div
      className="no-print report-export-bar"
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-end",
        justifyContent: "space-between",
        gap: 12,
        paddingTop: 8,
        borderBottom: `1px solid ${border}`,
        background: surface,
      }}
    >
      <nav role="tablist" aria-label="Report documents" style={{ display: "flex", gap: 4 }}>
        {tabs.map((tab) => (
          <Link
            key={tab.key}
            to={tab.to}
            role="tab"
            aria-selected={tab.active}
            style={{
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
              padding: "8px 12px 10px",
              fontSize: 12,
              fontWeight: 600,
              textDecoration: "none",
              color: tab.active ? textActive : textMuted,
              background: "transparent",
            }}
          >
            {tab.label}
            {tab.active ? (
              <span
                aria-hidden
                style={{
                  position: "absolute",
                  left: 10,
                  right: 10,
                  bottom: 0,
                  height: 2,
                  borderRadius: 2,
                  background: accent,
                }}
              />
            ) : null}
          </Link>
        ))}
      </nav>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8, paddingBottom: 8 }}>
        <a href={pdfHref} style={btnStyle} title="Download PDF">
          Export PDF
        </a>
        <a href={htmlHref} style={btnStyle} title="Download HTML">
          Export HTML
        </a>
      </div>
    </div>
  );
}
